import { keyToIndex, indexToKey } from "../../util/functions"
import { Scenario, Licenses, OSs, APIs, Platforms } from "./data"

const VERSION = 4

export const packScenario = (scenario: Scenario): string => {
    const license = keyToIndex(Licenses, scenario.license) // 5 bits
    const os = keyToIndex(OSs, scenario.os) // 3 bits
    const api = keyToIndex(APIs, scenario.api) // 3 bits
    const packageManager = keyToIndex(APIs[scenario.api].packageManagers, scenario.packageManager, true) // 3 bits
    const platform = keyToIndex(Platforms, scenario.platform) // 3 bits
    const framework = keyToIndex(APIs[scenario.api].frameworks, scenario.framework, true) // 3 bits
    const clusterManager = scenario.clusterManager?1:0 // 1 bit
    const containerClient = scenario.containerClient?1:0 // 1 bit
    const containerServer = scenario.containerServer?1:0 // 1 bit
    const containerOrchestration = scenario.containerOrchestration?1:0 // 1 bit
    const encoded = (license) | (os << 5) | (api << 8) | (packageManager << 11) | (platform << 14) | (framework << 17) | (clusterManager << 20) | (containerClient << 21) | (containerServer << 22) | (containerOrchestration << 23)
    return `v${VERSION}-${encoded}`
}

export const unpackScenario = (packed: string): Scenario => {
    const regex = /v([0-9]+)-(.*)/i
    const found = packed.match(regex)
    let data = packed, version = VERSION
    if(found) {
        version = parseInt(found[1])
        data = found[2]
    }
    switch(version) {
        case 1:
            return unpackScenarioV1(data)
        case 2:
            return unpackScenarioV2(data)
        case 3:
        case 4:
            return unpackScenarioV3(data)
        default:
            throw new Error(`Cannot parse scenario data for version ${version}`)
    }
}

export const unpackScenarioV3 = (data: string): Scenario => {

    const encoded = parseInt(data)
    const mask = (bits: number, shift: number) => ((1 << (bits)) - 1) << shift
    const unpack = (bits: number, shift: number) => (encoded & mask(bits, shift)) >> shift

    const license = unpack(5,0)
    const os = unpack(3, 5)
    const api = unpack(3, 8)
    const packageManager = unpack(3, 11)
    const platform = unpack(3, 14)
    const framework = unpack(3, 17)
    const clusterManager = unpack(1, 20)
    const containerClient = unpack(1, 21)
    const containerServer = unpack(1, 22)
    const containerOrchestration = unpack(1, 23)

    const apiKey = indexToKey(APIs, api)
    const apiObj = APIs[apiKey]

    return {
        license: indexToKey(Licenses, license),
        os: indexToKey(OSs, os),        
        api: apiKey,
        packageManager: apiObj.packageManagers ? indexToKey(apiObj.packageManagers, packageManager, true) : '',
        framework: apiObj.frameworks ? indexToKey(apiObj.frameworks, framework, true) : '',
        platform: indexToKey(Platforms, platform),
        clusterManager: !!clusterManager,
        containerClient: !!containerClient,
        containerServer: !!containerServer,
        containerOrchestration: !!containerOrchestration
    }
}

export const unpackScenarioV1_2 = (data: string, dataVersion: number): Scenario => {

    const encoded = parseInt(data)
    const mask = (bits: number, shift: number) => ((1 << (bits)) - 1) << shift
    const unpack = (bits: number, shift: number) => (encoded & mask(bits, shift)) >> shift

    const license = unpack(5,0)
    const os = unpack(3, 5)
    const api = unpack(3, 8)
    const packageManager = unpack(3, 11)
    const platform = unpack(3, 14)
    const framework = unpack(3, 17)
    const clusterManager = unpack(1, 20)
    const containerClient = unpack(1, 21)
    const containerServer = unpack(1, 22)
    const containerOrchestration = unpack(1, 23)
    
    const apiKey = indexToKey(APIs, api)
    const apiObj = APIs[apiKey]

    return {
        license: indexToKey(Licenses, license),
        os: indexToKey(OSs, os),        
        api: apiKey,
        packageManager: apiObj.packageManagers ? indexToKey(apiObj.packageManagers, packageManager, true) : '',
        framework: apiObj.frameworks ? indexToKey(apiObj.frameworks, framework, true) : '',
        platform: indexToKey(Platforms, platform),
        clusterManager: !!clusterManager,
        containerClient: !!containerClient,
        containerServer: !!containerServer,
        containerOrchestration: !!containerOrchestration
    }
}

export const unpackScenarioV2 = (data: string): Scenario => {
    return unpackScenarioV1_2(data, 2)
}

export const unpackScenarioV1 = (data: string): Scenario => {    
    return unpackScenarioV1_2(data, 1)
}